import { CenteredCircularProgress } from '../common/CenteredCircularProgress';
import { AutomationDialogContent } from './AutomationDialogContent';
import { AutomationFormVariant } from '../../types/enums/AutomationFormVariant';
import { useSelector } from 'react-redux';
import { selectDefaultCreationEnvironment } from '../pages/environments/environmentsReducer';
import useAutomationApiPerType from './useAutomationApiPerType';
import { automationsSortOptions } from './consts';
import { AutomationAutomationsContextProvider } from '../alerts/AutomationAutomationsContextProvider';
import { selectCrmOrgAutomations } from '../../reducers/global/automationReducers';
import { useMemo } from 'react';
import { selectDefaultCreationCrmOrgId } from '../../reducers/userInfoReducer';
import { useGetAutomationFilters } from './filters/helpers';

const Automations = () => {
  const defaultCreationCrmOrgId = useSelector(selectDefaultCreationCrmOrgId);
  const automations = useSelector(selectCrmOrgAutomations(defaultCreationCrmOrgId ?? ''));
  const memoizedAutomations = useMemo(() => automations ?? [], [automations]);
  const automationsVariant = AutomationFormVariant.AUTOMATIONS;
  const { onSaveOrCreate, onToggleActivation, onDeleteAutomation, onDeployAutomation } =
    useAutomationApiPerType({ automationVariant: automationsVariant });

  const filters = useGetAutomationFilters({
    automations: memoizedAutomations,
    crmOrgId: defaultCreationCrmOrgId ?? '',
  });
  const crmOrg = useSelector(selectDefaultCreationEnvironment);

  if (!automations) return <CenteredCircularProgress />;

  return (
    <>
      {crmOrg && (
        <AutomationDialogContent
          dataTestId="automations-page"
          onSaveOrCreate={onSaveOrCreate}
          onToggleActivation={onToggleActivation}
          onDeleteAutomation={onDeleteAutomation}
          automations={memoizedAutomations}
          crmOrgId={defaultCreationCrmOrgId ?? ''}
          sortOptions={automationsSortOptions}
          onDeployAutomation={onDeployAutomation}
          filters={filters}
        />
      )}
    </>
  );
};

const AutomationsWithContext = () => {
  return (
    <AutomationAutomationsContextProvider>
      <Automations />
    </AutomationAutomationsContextProvider>
  );
};

export default AutomationsWithContext;
